//@flow
import React, { Component } from "react";
// import Field from './field';
import css from "./form.module.scss";
import { Validator } from "../services/validators";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
type Props = {};

type State = {
  data: Object,
  errorFields: Array<string>,
  submitStatus: number,
  submitPending: boolean,
};

export class Form extends Component<Props, State> {
  static defaultProps: Object = {};

  Required: Array<string>;

  constructor(props: Object) {
    super(props);

    // this.Required = [
    //     'venue_name', 'venue_address', 'venue_postcode',
    //     "event_type", "event_date", "event_start_time", "event_finish_time", "event_guestcount",
    //     "package_type",];

    // if (props.showAgent) {
    //     this.Required.push(...['agent_name', 'agent_contact_number', 'agent_contact_email',]);
    // }

    // let d = {};
    // switch (this.props.agent) {
    //     case ("signature"): {
    //         d.agent_name = "Signature Living";
    //         break;
    //     }
    //     default: { }
    // }

    this.state = {
      data: {},
      errorFields: [],
      submitStatus: 0,
      submitPending: false,
    };
  }

  handleSelectChange(e: SyntheticInputEvent<*>) {
    // $FlowFixMe
    var options = e.target.options;
    let v = null;
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        v = options[i].value;
      }
    }

    let data = this.state.data;
    data[e.target.name] = v;
    this.setState({
      data: data,
    });
  }
  handleChange(e: SyntheticInputEvent<*>): void {
    let data = this.state.data;

    data[e.target.name] = e.target.value;

    if (!data[e.target.name]) {
      delete data[e.target.name];
    }

    this.setState({
      data: data,
    });
  }

  handleClearForm(e: SyntheticInputEvent<*>) {
    e.preventDefault();

    window.location.reload();
  }

  handleSubmit(i: SyntheticInputEvent<*>) {
    i.preventDefault();

    /// validate form
    let hasError = false;
    let errorFields = [];
    Object.entries(this.state.data).forEach((e) => {
      let isValid = true;
      if (Validator[e[0]]) isValid = Validator[e[0]](e[1]);
      if (!isValid) {
        hasError = true;
        errorFields.push(e[0]);
      }
    });

    this.Required.forEach((e) => {
      if (!this.state.data[e]) {
        console.error("Field is required", e);
        hasError = true;
        errorFields.push(e);
      }
    });

    if (hasError) {
      this.setState({ errorFields: errorFields });
      // console.log(errorFields)

      window.alert("Please check the form for errors or missing information");
    } else {
      const c = window.confirm("Submit entry now?");
      if (c) {
        this.setState({ submitPending: true });
        fetch("https://api.indemandradio.com/comps/entry", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify(this.state.data),
        }).then((response) => {
          console.log(response.status);
          //   if (response.status === 200) {
          // window.alert("Your entry was successfully submitted!");
          this.setState({ submitStatus: response.status, submitPending: false });
          //   } else {
          //     window.alert("Sorry, something went wrong!");
          //   }
        });
      }
    }
  }

  SubmitButtons: Object = (
    <div className={css.buttons}>
      <input type="submit" className={css.submit} value="Submit Entry"></input>
      <button className={css.clearForm} onClick={(e) => this.handleClearForm(e)}>
        Clear form
      </button>
    </div>
  );

  Loading: Object = (
    <div className={css.loadingWrapper}>
      <FontAwesomeIcon className={[css.loadingIcon].join(" ")} spin={true} icon={faSync} />
    </div>
  );
  /*
    render() {
        // console.log(this.props.agent)
        return <div className={css.wrapper}>
            <form onSubmit={(e) => this.handleSubmit(e)}>
                <p>(*) required field</p>
                {this.props.showAgent &&
                    <fieldset>
                        <legend>Booking Agent details</legend>
                        <Field name="agent_name"
                            title="Booking agent name"
                            isDisabled={this.props.agent !== undefined}
                            description="Name of booking agent"
                            placeholder="name"
                            data={this.state.data}
                            onChange={(e) => this.handleChange(e)}
                            requiredFields={this.Required}
                            errorFields={this.state.errorFields} />

                        <Field name="agent_contact_number"
                            title="Contact number"
                            description="Contact number for booking agent"
                            placeholder="07123 456 789"
                            data={this.state.data}
                            onChange={(e) => this.handleChange(e)}
                            requiredFields={this.Required}
                            errorFields={this.state.errorFields} />

                        <Field name="agent_contact_email"
                            title="Booking agent email"
                            description="Email of booking agent"
                            placeholder="name@email.com"
                            data={this.state.data}
                            onChange={(e) => this.handleChange(e)}
                            requiredFields={this.Required}
                            errorFields={this.state.errorFields} />
                    </fieldset>
                }
                <fieldset>
                    <legend>Venue details</legend>

                    <Field name="venue_name"
                        title="Venue name"
                        description="Where the party is being held!"
                        placeholder="name"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                    <Field name="venue_address"
                        type="textarea"
                        title="Venue address"
                        description="Street address & town of the venue"
                        placeholder="address"
                        data={this.state.data}
                        requiredFields={this.Required}
                        onChange={(e) => this.handleChange(e)}
                        errorFields={this.state.errorFields} />

                    <Field name="venue_postcode"
                        title="Venue postcode"
                        description=""
                        placeholder="postcode"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                </fieldset>
                <fieldset>
                    <legend>Venue contact</legend>
                    {this.props.showAgent && <p>Leave this section blank if same as above</p>}
                    <Field name="venue_contact_name"
                        title="Venue staff contact name"
                        description="The person at the venue who is the main point of contact for this event"
                        placeholder="name"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                    <Field name="venue_contact_number"
                        type="tel"
                        title="Venue contact phone number"
                        description="Venue contact's phone number"
                        placeholder="07123 456 789"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                    <Field name="venue_contact_email"
                        type="text"
                        title="Venue contact email address"
                        description="Venue contact's email address"
                        placeholder="person@thevenue.com"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />
                </fieldset>

                <fieldset>
                    <legend>Customer / Party details</legend>

                    <Field name="customer_name"
                        title="Customer name"
                        description="Name of the lead customer and point of contact in the party"
                        placeholder="customer name"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                    <Field name="customer_contact_number"
                        type="tel"
                        title="Customer phone number"
                        description="Phone number for customer contact"
                        placeholder="07123 456 789"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                    <Field name="customer_contact_email"
                        type="text"
                        title="Customer email"
                        description="Customer contact email"
                        placeholder="name@email.com"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                </fieldset>

                <fieldset>
                    <legend>Event details</legend>
                    <Field name="event_type"
                        title="Event type"
                        description="For example: wedding, 40th birthday etc"
                        placeholder=""
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                    <Field name="event_date"
                        title="Event date"
                        type="text"
                        description="Date of the event"
                        placeholder="DD/MM/YYYY"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                    <Field name="event_start_time"
                        type="text"
                        title="Start time of performance"
                        description="What time will the performers on this booking be starting their show? If you're not sure, just estimate for now."
                        placeholder="HH:MM"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                    <Field name="event_finish_time"
                        title="Finish time"
                        type="text"
                        description="What time does it finish? If you're not sure, just estimate for now."
                        placeholder="HH:MM"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />



                    <Field name="event_guestcount"
                        type="number"
                        title="Estimated number of guests"
                        description="How many guests you expect to attend the event? If you're not sure, just estimate for now."
                        placeholder="0"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />
                </fieldset>


                <fieldset>
                    <legend>Logistics</legend>

                    <Field name="loadin_time"
                        type="text"

                        title="Time of equipment install"
                        description="What time can we access the venue to load in and set up the equipment? If you're not sure, just estimate for now."
                        placeholder="HH:MM"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                    <Field name="loadin_finish"
                        type="text"
                        title="Install finish time"
                        description="And what time must we be ready by? If you're not sure, just estimate for now."
                        placeholder="HH:MM"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />


                    <Field name="loadout_time"
                        title="Derig curfew"
                        type="text"

                        description="When can we load out the equipment? Can this be done the next day or must it be clear on the night. If you're not sure, just estimate for now."
                        placeholder="HH:MM"
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields} />

                    <Field name="package_type"
                        type="select"
                        title="Equipment package type"
                        description="Which package are you interested in?"
                        placeholder="DROPDOWN"
                        data={this.state.data}
                        onChange={(e) => this.handleSelectChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields}
                        options={[<option key="none" value="none"></option>, <option key="basic" value="basic">Basic</option>,
                        <option key="standard" value="standard">Standard</option>,
                        <option key="exclusive" value="exclusive">Exclusive</option>,
                        <option key="premium" value="premium">Premium</option>,
                        <option key="custom" value="custom">Custom</option>]}
                        defaultValue="none"
                    />
                    

                </fieldset>



                <fieldset>
                    <legend>Notes</legend>

                    <Field name="comments"
                        type="textarea"
                        title="Extra notes or special requirements"
                        description="Anything else you think we should be aware of, or any special requests"
                        placeholder=""
                        data={this.state.data}
                        onChange={(e) => this.handleChange(e)}
                        requiredFields={this.Required}
                        errorFields={this.state.errorFields}
                    />


                </fieldset>


                <div className={css.buttons}>
                    <input type="submit" className={css.submit} value="Submit"></input>
                    <button className={css.clearForm} onClick={(e) => this.handleClearForm(e)}>Clear form</button>
                </div>
            </form>
        </div>;
    }
    */
}
export default Form;
